export default class KeyVisual {
    constructor() {
        this.mainvisual = document.querySelector(".js-mainvisual");
        this.mainvisualImg = document.querySelector(".top-mainvisual__img");

        this.scrollTimer = null;

        this._handleScroll = this._handleScroll.bind(this);

        this._init();
    }

    _init() {
        this._setKVPositionVars();
        window.addEventListener("scroll", this._handleScroll);
    }

    _setKVPositionVars() {
        if (!this.mainvisualImg) {
            return;
        }

        const { pcTop, pcLeft, spTop, spLeft } = this.mainvisualImg.dataset;

        if (pcTop) {
            this.mainvisualImg.style.setProperty("--kv-pc-top", pcTop);
        }
        if (pcLeft) {
            this.mainvisualImg.style.setProperty("--kv-pc-left", pcLeft);
        }
        if (spTop) {
            this.mainvisualImg.style.setProperty("--kv-sp-top", spTop);
        }
        if (spLeft) {
            this.mainvisualImg.style.setProperty("--kv-sp-left", spLeft);
        }
    }

    _handleScroll() {
        // スクロール中は-darkクラスを付加
        this.mainvisual.classList.add("-dark");

        // 既存のタイマーをクリア
        if (this.scrollTimer !== null) {
            clearTimeout(this.scrollTimer);
        }

        // スクロール終了後に-darkクラスを解除
        this.scrollTimer = setTimeout(() => {
            this.mainvisual.classList.remove("-dark");
        }, 150);
    }
}
